import { ApiHandler as makeReq } from "./ApiHandler";
import { FileUploadApiHandler as makeFileUploadReq } from "./ApiHandler";

const API_BASE = "cdktalentacquisition/api";

export default {
  loginUser: credentials => {
    return makeReq({
      url: `${API_BASE}/userlogin`,
      method: "POST",
      data: credentials
    });
  },
  forgotPassword: userNameOrEmail => {
    return makeReq({
      url: `${API_BASE}/forgotpassword`,
      method: "POST",
      data: userNameOrEmail
    });
  },
  changePassword: credentials => {
    return makeReq({
      url: `${API_BASE}/changepassword`,
      method: "POST",
      data: credentials
    });
  },
  getCandidateDetails: candidateId => {
    return makeReq({
      url: `${API_BASE}/getuser`,
      method: "POST",
      data: {
        userId: candidateId
      }
    });
  },
  getCandidateReportData: candidateId => {
    return makeReq({
      url: `${API_BASE}/getcandidatereport`,
      method: "POST",
      data: {
        userId: candidateId
      }
    });
  },
  getCandidatesList: () => {
    return makeReq({
      url: `${API_BASE}/getcandidatelist`,
      method: "GET"
    });
  },
  getCandidatesJoiningList: () => {
    return makeReq({
      url: `${API_BASE}/getcandidateJoiningList`,
      method: "GET"
    });
  },
  getUsersList: () => {
    return makeReq({
      url: `${API_BASE}/getuserlist`,
      method: "GET"
    });
  },
  getGendersList: () => {
    return makeReq({
      url: `${API_BASE}/gender/`,
      method: "GET"
    });
  },
  getUserRoles: () => {
    return makeReq({
      url: `${API_BASE}/userroles/`,
      method: "GET"
    });
  },
  getMaritalStatusList: () => {
    return makeReq({
      url: `${API_BASE}/maritaltype/`,
      method: "GET"
    });
  },
  getStatesList: () => {
    return makeReq({
      url: `${API_BASE}/states/`,
      method: "GET"
    });
  },
  saveCandidateDetails: candidateDetails => {
    return makeReq({
      url: `${API_BASE}/updatecandidate`,
      method: "POST",
      data: candidateDetails
    });
  },
  createNewUser: userDetails => {
    return makeReq({
      url: `${API_BASE}/adduser`,
      method: "POST",
      data: userDetails
    });
  },
  updateUserDetails: userDetails => {
    return makeReq({
      url: `${API_BASE}/updateuser`,
      method: "POST",
      data: userDetails
    });
  },
  deleteUser: userDetails => {
    return makeReq({
      url: `${API_BASE}/deleteuser`,
      method: "POST",
      data: userDetails
    });
  },
  inviteUser: userDetails => {
    return makeReq({
      url: `${API_BASE}/sendinvitation`,
      method: "POST",
      data: userDetails
    });
  },
  uploadDocuments: (userDocuments, userId) => {
    const httpHeaders = { userId };
    return makeFileUploadReq({
      url: `${API_BASE}/uploaddocuments`,
      method: "POST",
      data: userDocuments,
      headers: new Headers(httpHeaders)
    });
  },
  getUserDocuments: userId => {
    const httpHeaders = { userId };
    return makeFileUploadReq({
      url: `${API_BASE}/getdocuments`,
      method: "GET",
      headers: new Headers(httpHeaders)
    });
  },
  onBoardUser: userDetails => {
    return makeReq({
      url: `${API_BASE}/sendOnBoardingInvitation`,
      method: "POST",
      data: userDetails
    });
  }
};
